import {
  aBigIntDataPoint,
  mockInsightCountsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockInsightCountsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightClosedCounts: [aBigIntDataPoint()],
          insightCounts: [aBigIntDataPoint()],
        },
      });
    }
  ),
];
